module.exports = __webpack_public_path__ + "img/brackets-curly.9ae8c1eb.svg";